import React, { FC, RefObject } from 'react';

import './taskDetailsContent.scss';

import { Task, ShelvesRefs } from '../../common/types';
import { ShelfProvider } from '../../components/task/components/ShelfStore';

interface ComponentProps {
  task: Task;
  shelvesRefs: ShelvesRefs;
  scrollRef: RefObject<HTMLDivElement> | null;
  selectedShelf: string;
  setSelectedShelf(shelfId: string, isChangeTab: boolean): void;
  shelfComponent: any; // TODO REFACTOR ZEKA if possible find a way to type it so it only accepts shelf components
}

export const TaskDetailsContent: FC<ComponentProps> = ({
  task,
  scrollRef,
  shelvesRefs,
  shelfComponent,
  ...props
}) => {
  const { id, shelves } = task;
  const ShelfComponent = shelfComponent;
  return (
    <div className="ui-components-task-details-content_container" ref={scrollRef}>
      {id &&
        shelves.map((shelf) => (
          <div key={`ref${shelf.id}`} ref={shelvesRefs[shelf.id]}>
            <ShelfProvider shelf={shelf}>
              <ShelfComponent
                shelf={shelf}
                task={task}
                {...(props as any)}
                workflowId={task.workflowId}
              />
            </ShelfProvider>
          </div>
        ))}
    </div>
  );
};

export default TaskDetailsContent;
